import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AbstractDetailsComponent } from '../../shared/abstract-details.component';
import { Placement } from '../../../interfaces/placement';

@Component({
	selector: 'placement-details',
	templateUrl: './placement-details.component.html',
	styleUrls: ['./placement-details.component.scss']
})


export class PlacementDetailsComponent extends AbstractDetailsComponent implements OnInit {

	@ViewChild('formRef', { static: true }) form: NgForm;
	embedcode = '';
	baseurl: string;
	entity: Placement;

	constructor(
		protected route: ActivatedRoute,
		protected location: Location
	) {

		super(route, location);
		this.entityConfiguration = {
			name: 'placement',
			entityType: 'Placement',
			parentPath: '/library/placements',
			basePath: '/library/placement/',
			versioned: true,
			showVersionMetadata: true,
			versionMetadataToSave: {
				bbcomment: ''
			},
			defaults: {
				subtype: 'versioned'
			}
		};
	}

	ngOnInit() {
		super.ngOnInit();
	}
}
